import React from "react";
import { Container, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Moment from "moment";
import "./CdCalendarExceptions.scss";
import messages from '../../assets/i18n'
import lodashTruncate from "../../utils/lodashTruncate";

function CdCalendarExceptions(props) {

    const dispatch = useDispatch();
    const lang = useSelector(state => state.language.name);

    const { exceptions } = props;

    return (
        <div className="cd-calendar-exceptions">
            <Container className="extra-rounded-top extra-rounded-bottom container-cd-calendar-exceptions">
                <Row className="px-2">
                    <Col className="text-left py-2">
                        <span className="text-3 font-weight-bold">
                            {messages[lang].upcomingException}
                        </span>
                    </Col>
                </Row>
                <hr className="custom-hr-style-1" />
                {exceptions !== null ?
                    <Container className="py-4">
                        <Row className="text-center">
                            <Col xs={6} className="bg-color-tertiary border-right py-2 extra-rounded-top-left text-left">
                                <span className="text-2 text-color-tertiary">
                                    {messages[lang].exception}
                                </span>
                            </Col>
                            <Col xs={5} className="bg-color-tertiary border-left border-right py-2 ">
                                <span className="text-2 text-color-tertiary">
                                    {messages[lang].date}
                            </span>
                            </Col>
                            <Col xs={1} />
                        </Row>

                        <div className="cd-calendar-exceptions-body">

                            {exceptions.map((exception) => {
                                return (
                                    <Row className="text-center mt-2" key={exception.id}>
                                        <Col xs={6} className="bg-color-secondary border-right py-2 text-left">
                                            <span className="text-2 text-color-tertiary">
                                                <OverlayTrigger
                                                    placement="top"
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={
                                                    <Tooltip>
                                                       {exception.descricao}
                                                    </Tooltip>
                                                }>
                                                    <span> {lodashTruncate(exception.descricao, 25)} </span>
                                                </OverlayTrigger>
                                            </span>
                                        </Col>
                                        <Col xs={5} className="bg-color-secondary border-left border-right py-2 ">
                                            <span className="text-2 text-color-tertiary">
                                                {Moment(exception.data).format('LL')}
                                            </span>
                                        </Col>
                                        <Col xs={1} className="d-flex justify-content-center">
                                            <button
                                                className="btn-remove"
                                                id="reconcile_remove_file_button"
                                                onClick={() => dispatch({ type: "DELETE_CD_EXCEPTION", id: exception.id})}
                                            >
                                                <i className="icon-remove" />
                                            </button>
                                        </Col>
                                    </Row>
                                )
                            })}

                        </div>
                    </Container>
                    :
                    <h1>
                        {messages[lang].NotFoundExceptions}
                    </h1>
                }
            </Container>
        </div>
    );
}

export default CdCalendarExceptions;
